<template>
    <div v-if="field">
      <transition-group name="fade">
        <div class="card has-text-centered" v-if="field.type === 'STAR5'" :key="field._id">
          <div class="field">
            <div class="card-content has-background-info hero is-halfheight">
              <label class="label has-text-white text-padding has-text-weight-light is-size-2">{{field.description}}</label>
            </div>
            <div class="card-content">
              <div class="section">
                <rating-field v-model="feedbackResponse[field._id]" class=""></rating-field>
              </div>
            </div>
          </div>
        </div>
        <div class="card has-text-centered" v-if="field.type === 'TEXT'" :key="field._id">
          <div class="field">
            <div class="card-content has-background-info hero is-halfheight">
              <label class="label has-text-white text-padding has-text-weight-light is-size-2">{{field.description}}</label>
            </div>
            <div class="control card-content text-xs-center">
              <textarea class="textarea" :placeholder="field.description" v-model.lazy="feedbackResponse[field._id]"></textarea>
            </div>
          </div>
          <div class="buttons are-medium is-centered">
            <a class="button is-link" v-on:click="next" v-if="question < (feedbackItems.length - 1)">Next</a>
          </div>
        </div>
        <div class="card has-text-centered" v-if="field.type === 'PICKER' && !field.allowMultiple" :key="field._id">
          <div class="field">
            <div class="card-content has-background-info hero is-halfheight">
              <label class="label has-text-white text-padding has-text-weight-light is-size-2">{{field.description}}</label>
            </div>
            <div class="card-content">
              <div class="section">
                <div class="select is-large">
                  <select v-model="feedbackResponse[field._id]">
                    <option v-for="option in field.options" :key="option">{{option}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card has-text-centered" v-if="field.type === 'YESNO'" :key="field._id">
          <div class="field">
            <div class="card-content has-background-info hero is-halfheight">
              <label class="label has-text-white text-padding has-text-weight-light is-size-2">{{field.description}}</label>
            </div>
            <div class="card-content">
              <div class="section">
                <label class="radio button is-size-1-widescreen is-size-2-mobile is-success">
                  <input type="radio" v-model="feedbackResponse[field._id]" value="Yes" class="radio-button">
                  <span class="icon is-large is-marginless">
                    <font-awesome-icon icon="thumbs-up"/>
                  </span>
                </label>
                <label class="radio button is-size-1-widescreen is-size-2-mobile is-warning">
                  <input type="radio" v-model="feedbackResponse[field._id]" value="No" class="radio-button">
                  <span class="icon is-large is-marginless">
                    <font-awesome-icon icon="thumbs-down"/>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="card has-text-centered" v-if="field.type === 'PICKER' && field.allowMultiple" :key="field._id">
          <div class="field">
            <div class="card-content has-background-info hero is-halfheight">
              <label class="label has-text-white text-padding has-text-weight-light is-size-2">{{field.description}}</label>
            </div>
            <div class="section">
              <div class="select is-multiple w-100">
                <select multiple v-model="feedbackResponse[field._id]" class="w-100">
                  <option v-for="option in field.options" :key="option">{{option}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="buttons are-medium is-centered">
            <a class="button is-link" v-on:click="next" v-if="question < (feedbackItems.length - 1)">Next</a>
          </div>
        </div>
      </transition-group>
      <div class="buttons are-medium is-centered margin-5 padding-5">
          <transition name="fade">
            <a class="button is-link" v-if="question === (feedbackItems.length - 1)" v-on:click="submitFeedbackResponse" >Submit</a>
          </transition>
      </div>
    </div>
</template>
<script>
import RatingField from '@/components/ux/RatingField'

export default {
  name: 'FeedbackStepper',
  props: ['campaignData'],
  components: {
    RatingField
  },
  data () {
    return {
      question: -1,
      feedbackResponse: {}
    }
  },
  watch: {
    feedbackResponse: {
      handler: function (item) {
        if (this.question < (this.feedbackItems.length - 1)) {
          if (this.field && (this.field.type === 'TEXT' || (this.field.type === 'PICKER' && this.field.allowMultiple))) {
            return false;
          }
          this.next()
        }
      },
      deep: true
    },
    campaignData: function (newValue) {
      this.updateFeedbackResponse(newValue)
    }
  },
  computed: {
    feedbackItems () {
      if (this.campaignData && this.campaignData.campaign) {
        return this.campaignData.campaign.feedbackItems
      }
      return []
    },
    field () {
      return this.feedbackItems[this.question]
    }
  },
  methods: {
    updateFeedbackResponse (campaignData) {
      if (!campaignData || !campaignData.campaign) {
        return
      }
      this.feedbackResponse = campaignData.campaign.feedbackItems.reduce((map, obj) => {
        if (obj.type === 'PICKER' && obj.allowMultiple) {
          map[obj._id] = []
        } else {
          map[obj._id] = null
        }
        return map
      }, {})
    },

    submitFeedbackResponse () {
      if (!this.campaignData.customer) {
        this.$emit('customerinfo', this.feedbackResponse)
      } else {
        this.$emit('submit', this.feedbackResponse)
      }
    },

    next () {
      this.question++
    },

    prev () {
      this.question--
    }
  }
}
</script>
<style scoped>
  .radio-button{
    -webkit-appearance: none;
  }
</style>
